const defaultState = {};

const mutations = {
    setNetworkTypeState(state, networkType) {
        Object.assign(state, networkType);
    },
    resetNetworkTypeState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getNetworkTypeInfo({ commit, dispatch }, networkTypeId) {
        try {
            const { data } = await this.$rq.getNetworkTypes();
            const networkType = data.types.find(type => type.id === networkTypeId);
            commit('setNetworkTypeState', networkType);
        } catch (err) {
            dispatch('resetNetworkTypeInfo');
        }
    },
    resetNetworkTypeInfo({ commit }) {
        commit('resetNetworkTypeState');
    },
};

const getters = {
    networkType: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
